module.exports = __webpack_public_path__ + "img/sapato.eaba59c7.png";